import { createSlice } from "@reduxjs/toolkit";

export const toast_position = {
  position: "bottom-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "colored",
};

const AuthMatrix = createSlice({
  name: "AuthMatrix",
  initialState: {
    allTransactionAuth: null,
    archiveRuleRes: null,
    createTransactionAuth: null,
    isLoading: false,
    isError: false,
  },
  extraReducers: (builder) => {},
});

export default AuthMatrix.reducer;
